// Builds the descriptive line shown under a charge (card brand / payment
// method). Shared by checkout, verification and the receipt so a charge reads
// the same everywhere.
// `ReactI18n.getIntlMessage` falls back to the raw locale string when any
// interpolation value is missing, so keys are only used when their values are
// present.
const presence = value => {
  if (value === null || value === undefined) return null;
  const trimmed = String(value).trim();
  return trimmed.length > 0 ? trimmed : null;
};

const isCardCharge = charge => {
  const chargeType = presence(charge.charge_type);
  if (chargeType) return chargeType.includes('card');
  return Boolean(presence(charge.cc_brand) || presence(charge.cc_last_4));
};

const cardDescription = (charge, translate) => {
  const brand = presence(charge.cc_brand);
  const last4 = presence(charge.cc_last_4);

  if (brand && last4) {
    return translate('cx.receipt.cc_info', { brand, last_4: last4 });
  }
  if (last4) {
    return translate('cx.receipt.cc_info_last_4', { last_4: last4 });
  }
  return translate('cx.receipt.cc_info_generic');
};

const chargeDescription = (charge, translate) => {
  if (!charge) return null;

  if (isCardCharge(charge)) return cardDescription(charge, translate);

  const paymentMethod = presence(charge.charge_type);
  if (paymentMethod === 'cash') {
    return translate('cx.receipt.payment_methods.cash');
  }
  if (paymentMethod === 'check') {
    return translate('cx.receipt.payment_methods.check');
  }
  if (paymentMethod) {
    return translate('cx.receipt.payment_info', {
      payment_method: paymentMethod.replace(/_/g, ' ')
    });
  }
  return translate('cx.receipt.payment_methods.other');
};

module.exports = chargeDescription;
module.exports.isCardCharge = isCardCharge;
